import { useNavigate, useParams, useLocation, useOutletContext } from 'react-router-dom';
import ContactPointModalForm from './ContactPointModalForm';

export default function ContactPointModalFormRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, channelType } = useParams();
  const { onContactPointUpdate } = useOutletContext<{ onContactPointUpdate: (updated: any) => void }>();
  const contactPointFromState = location.state?.contactPoint;

  const handleClose = () => {
    navigate(`/communication/contact/${id}/page-view`);
  };

  const handleSuccess = (updatedContactPoint: any) => {
    onContactPointUpdate(updatedContactPoint);
    navigate(`/communication/contact/${id}/page-view`, { replace: true });
  };

  // Dados para novo contact point ou usar dados do state
  const contactPointData = contactPointFromState || {
    id: '',
    type: channelType === 'phone' ? 'PHONE' : 'EMAIL',
    value: '',
    isActive: true,
    isPrimary: false,
    isWhatsapp: false,
    observation: '',
    templates: [],
    templateGroups: [],
  };

  return (
    <ContactPointModalForm
      contactId={id!}
      contactPointId={contactPointData.id || ''}
      type={contactPointData.type}
      currentValue={contactPointData.value}
      isActive={contactPointData.isActive}
      isPrimary={contactPointData.isPrimary}
      isWhatsapp={contactPointData.isWhatsapp}
      observation={contactPointData.observation}
      templates={contactPointData.templates}
      templateGroups={contactPointData.templateGroups}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
}
